import { useState } from "react"

export const useModal = () => {

 const [modal,setModal] = useState(null)
 const [reqData,setReqData] = useState(null)

 const openModal = (type,data=null)=>{
   setModal(type)
   setReqData(data)
 }

 const closeModal = ()=>{
   setModal(null)
   setReqData(null)
 }

 return {modal,reqData,openModal,closeModal}
}